(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["udk-discount-journey"] && !Shopify.designMode) return;
  try {
    
  (function () {
    var root = document.querySelector('[data-udk-discount-journey]');
    if (!root) return;

    var STORAGE_KEY = 'udkDiscountJourney.v1';

    function getCookie(name) {
      var pairs = document.cookie.split(';');
      for (var i = 0; i < pairs.length; i++) {
        var pair = pairs[i].trim();
        if (pair.indexOf(name + '=') === 0) {
          try {
            return decodeURIComponent(pair.slice(name.length + 1));
          } catch (e) {
            return null;
          }
        }
      }
      return null;
    }

    /* Cookie value is visitor-controlled. Take the first token if Shopify
       ever stacks codes comma-separated, then allowlist. */
    function sanitizeCode(raw) {
      if (!raw) return null;
      var code = raw.split(',')[0].trim();
      return /^[A-Za-z0-9_-]{1,40}$/.test(code) ? code : null;
    }

    function readShown() {
      try {
        return JSON.parse(sessionStorage.getItem(STORAGE_KEY)) || {};
      } catch (e) {
        return {};
      }
    }

    function markShown(code) {
      try {
        sessionStorage.setItem(STORAGE_KEY, JSON.stringify({ shownFor: code, shownAt: Date.now() }));
      } catch (e) {
        /* storage unavailable — worst case the card shows again on refresh */
      }
    }

    /* The card is an ARRIVAL acknowledgment, not ambient state: it shows only
       on the pageview the /discount/ redirect landed on. Our discount links
       always carry campaign params (utm_* on the links, _kx appended by
       Klaviyo) and Shopify forwards them onto the landing URL — later
       pageviews and direct visits don't have them. The sessionStorage flag
       covers refreshes, where the params DO survive. */
    function isDiscountLanding() {
      return /[?&](utm_[a-z]+|_kx)=/i.test(location.search);
    }

    /* textContent only — never innerHTML — the code comes from a cookie. */
    function setCode(container, code) {
      var slots = container.querySelectorAll('[data-udk-dj-code]');
      for (var i = 0; i < slots.length; i++) slots[i].textContent = code;
    }

    function showRibbon(code, designMode) {
      var ribbon = root.querySelector('[data-udk-dj-ribbon]');
      if (!ribbon) return;
      setCode(ribbon, code);
      ribbon.hidden = false;

      var autohideTimer = null;

      function hideRibbon() {
        if (autohideTimer) clearTimeout(autohideTimer);
        document.removeEventListener('pointerdown', onAnyPress, true);
        ribbon.classList.add('udk-dj__ribbon--leaving');
        setTimeout(function () {
          ribbon.hidden = true;
          ribbon.classList.remove('udk-dj__ribbon--leaving');
        }, 300);
      }

      /* All three dismissals (button, timeout, tap-anywhere) just hide the
         card — the shown-flag was already written at display time, so it
         won't return this session regardless of how it closes. */
      function onAnyPress(event) {
        if (ribbon.contains(event.target)) return;
        hideRibbon();
      }

      var autohideSeconds = parseInt(root.getAttribute('data-autohide-seconds'), 10) || 0;
      if (!designMode) {
        if (autohideSeconds > 0) {
          autohideTimer = setTimeout(hideRibbon, autohideSeconds * 1000);
        }
        /* Capture phase so presses on links/buttons still dismiss the card
           without interfering with their own behavior. */
        document.addEventListener('pointerdown', onAnyPress, true);
      }

      var dismiss = ribbon.querySelector('[data-udk-dj-dismiss]');
      if (dismiss) {
        dismiss.addEventListener('click', hideRibbon);
      }
    }

    function ensureBadge(code) {
      if (document.querySelector('[data-udk-dj-badge-mounted]')) return;
      var template = root.querySelector('[data-udk-dj-badge-template]');
      /* First .product-form__buttons is the main product form (quick-add
         modals render later); Kaching's bundle bars inject above it, so the
         badge lands between the bars and the Add to cart button. */
      var anchor = document.querySelector('.product-form__buttons');
      if (!template || !anchor) return;
      var badge = template.content.firstElementChild.cloneNode(true);
      setCode(badge, code);
      anchor.parentNode.insertBefore(badge, anchor);
    }

    function init() {
      var designMode = root.hasAttribute('data-design-mode');
      var code = designMode
        ? sanitizeCode(root.getAttribute('data-preview-code'))
        : sanitizeCode(getCookie('discount_code'));
      if (!code) return;

      if (root.hasAttribute('data-enable-ribbon')) {
        if (designMode) {
          showRibbon(code, true);
        } else if (isDiscountLanding() && readShown().shownFor !== code) {
          /* Flag BEFORE showing so a refresh can't re-trigger it even if the
             user never interacts with the card. A new code shows again. */
          markShown(code);
          showRibbon(code, false);
        }
      }

      if (root.hasAttribute('data-enable-badge') && root.getAttribute('data-page-type') === 'product' && !designMode) {
        ensureBadge(code);
        /* Insurance against DOM swaps on variant change (Dawn only replaces
           price/sku nodes, but re-ensuring is idempotent and cheap). */
        if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS === 'object') {
          subscribe(PUB_SUB_EVENTS.variantChange, function () {
            ensureBadge(code);
          });
        }
      }
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', init, { once: true });
    } else {
      init();
    }
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["udk-discount-signup"] && !Shopify.designMode) return;
  try {
    
(function () {
  // udk-capture.js is deferred and may execute before OR after this bundle.
  if (window.UDKCapture) initSignupForms();
  else document.addEventListener('udk:capture:ready', initSignupForms, { once: true });

  function initSignupForms() {
  var sections = document.querySelectorAll('.udk-signup');
  if (!sections.length) return;
  var C = window.UDKCapture;

  sections.forEach(function (section) {
    var formState = section.querySelector('[data-udk-signup-form-state]');
    var doneState = section.querySelector('[data-udk-signup-done]');
    var form = section.querySelector('[data-udk-signup-form]');
    var code = '';
    try { code = atob(section.dataset.codeEnc || ''); } catch (e) {}

    var getCountry = C.initCountrySelect(
      section.querySelector('[data-udk-cc]'),
      section.querySelector('[data-udk-cc-flag]')
    );

    function showSuccess() {
      formState.hidden = true;
      doneState.hidden = false;
      var codeEl = section.querySelector('.udk-signup__code-value');
      if (codeEl && !codeEl.textContent) codeEl.textContent = code; // runtime-only, anti-scrape
    }

    form.addEventListener('submit', function (e) {
      e.preventDefault();
      var err = form.querySelector('[data-udk-signup-error]');
      var btn = form.querySelector('[data-udk-signup-btn]');
      if (btn.disabled) return;

      var email = (form.querySelector('input[name="email"]').value || '').trim().toLowerCase();
      if (!C.validateEmail(email)) {
        err.textContent = "Hmm — that email doesn't look right. Try again?";
        err.hidden = false;
        return;
      }

      var profile = {
        email: email,
        subscriptions: { email: { marketing: { consent: 'SUBSCRIBED' } } }
      };

      // Phone is optional — but if provided, it must be valid.
      var rawPhone = (form.querySelector('input[name="phone"]').value || '').trim();
      if (rawPhone) {
        var dial = getCountry()[1];
        var digits = C.normalizePhone(rawPhone, dial);
        if (!digits) {
          err.textContent = "That phone number doesn't look right — fix it or leave it blank.";
          err.hidden = false;
          return;
        }
        profile.phone_number = '+' + dial + digits;
        profile.subscriptions.sms = { marketing: { consent: 'SUBSCRIBED' } };
      }

      err.hidden = true;
      btn.disabled = true;
      C.subscribe({
        company: section.dataset.company,
        list: section.dataset.list,
        source: 'Inline Newsletter', // $source attribution vs the popup
        profile: profile
      }).then(function (r) {
        btn.disabled = false;
        if (r.ok || r.retryable) {
          // retryable = auto-queued in the shared outbox; don't block the reward.
          C.writeState({ completedAt: Date.now(), email: email }); // popup stops appearing too
          showSuccess();
        } else {
          err.textContent = r.detail || "That was rejected — double-check your details and try again.";
          err.hidden = false;
        }
      });
    });

    var copyBtn = section.querySelector('[data-udk-code-copy]');
    copyBtn.addEventListener('click', function () {
      var label = copyBtn.querySelector('[data-udk-code-label]');
      var done = function () { label.textContent = 'Copied!'; };
      if (navigator.clipboard && navigator.clipboard.writeText) {
        navigator.clipboard.writeText(code).then(done, done);
      } else done();
    });
  });
  }
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["udk-ministry-bundle"] && !Shopify.designMode) return;
  try {
    
class MinistryGallery extends HTMLElement {
  connectedCallback() {
    this.imgs = Array.from(this.querySelectorAll('.udk-mob__gallery-img'));
    this.thumbs = Array.from(this.querySelectorAll('[data-gthumb]'));
    this.thumbs.forEach((t) => {
      t.addEventListener('click', () => this.show(parseInt(t.dataset.gthumb, 10)));
    });
  }

  show(i) {
    this.imgs.forEach((img) => img.classList.toggle('is-active', parseInt(img.dataset.gindex, 10) === i));
    this.thumbs.forEach((t) => t.classList.toggle('is-active', parseInt(t.dataset.gthumb, 10) === i));
  }
}

class MinistryOrderBuilder extends HTMLElement {
  connectedCallback() {
    this.packSize = parseInt(this.dataset.packSize, 10) || 5;
    this.tier2Min = parseInt(this.dataset.tier2Min, 10) || 10;

    this.cfg = {
      game: JSON.parse(this.dataset.game),
      devo: this.dataset.devo ? JSON.parse(this.dataset.devo) : null,
      book: this.dataset.book ? JSON.parse(this.dataset.book) : null,
    };

    // Quantities (in units). Games start at one case; add-ons match games.
    this.qty = { game: this.packSize, devo: this.packSize, book: this.packSize };
    this.match = { devo: true, book: true };

    // Respect storefront availability: never offer or try to add an out-of-stock product.
    ['game', 'devo', 'book'].forEach((k) => {
      if (this.unavail(k)) {
        this.qty[k] = 0;
        if (k !== 'game') this.match[k] = false;
      }
    });

    this.addBtn = this.querySelector('[data-add]');
    this.errorEl = this.querySelector('[data-error]');

    this.bindEvents();
    this.render();
  }

  unavail(key) {
    const c = this.cfg[key];
    return !c || !c.id || c.avail === false;
  }

  bindEvents() {
    this.querySelectorAll('.udk-mob__preset').forEach((btn) => {
      btn.addEventListener('click', () => {
        this.setQty('game', parseInt(btn.dataset.preset, 10));
      });
    });

    this.querySelectorAll('[data-stepper]').forEach((stepper) => {
      const key = stepper.dataset.stepper;
      stepper.querySelectorAll('[data-dir]').forEach((step) => {
        step.addEventListener('click', () => {
          if (this.unavail(key)) return;
          const dir = parseInt(step.dataset.dir, 10);
          const min = key === 'game' ? this.packSize : 0;
          this.setQty(key, Math.max(min, this.qty[key] + dir * this.packSize));
          if (key !== 'game') this.match[key] = false; // manual change breaks the link
        });
      });
    });

    this.querySelectorAll('[data-match]').forEach((cb) => {
      const key = cb.dataset.match;
      cb.addEventListener('change', () => {
        if (this.unavail(key)) { cb.checked = false; return; }
        this.match[key] = cb.checked;
        if (cb.checked) this.qty[key] = this.qty.game;
        this.render();
      });
    });

    this.addBtn.addEventListener('click', () => this.addToCart());
  }

  setQty(key, value) {
    if (this.unavail(key)) return;
    this.qty[key] = value;
    if (key === 'game') {
      // Pull any matched add-ons along with the game count.
      ['devo', 'book'].forEach((k) => {
        if (!this.unavail(k) && this.match[k]) this.qty[k] = value;
      });
    }
    this.render();
  }

  unitPrice(key) {
    const c = this.cfg[key];
    if (!c) return 0;
    return this.qty[key] >= this.tier2Min ? c.t2 : c.t1;
  }

  money(cents) {
    return '$' + (cents / 100).toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 });
  }

  render() {
    let subtotal = 0;
    let retailTotal = 0;
    const parts = [];

    ['game', 'devo', 'book'].forEach((key) => {
      const c = this.cfg[key];
      if (!c) return;
      const unavailable = this.unavail(key);
      const row = this.querySelector(`[data-line="${key}"]`);
      if (row) row.classList.toggle('is-unavailable', unavailable);

      const q = unavailable ? 0 : this.qty[key];
      const line = this.unitPrice(key) * q;
      subtotal += line;
      retailTotal += c.retail * q;

      const countEl = this.querySelector(`[data-count="${key}"]`);
      if (countEl) countEl.textContent = q;
      const totalEl = this.querySelector(`[data-linetotal="${key}"]`);
      if (totalEl) totalEl.textContent = unavailable ? 'Unavailable' : (q > 0 ? this.money(line) : '—');
      const metaEl = this.querySelector(`[data-meta="${key}"]`);
      if (metaEl) {
        metaEl.textContent = unavailable
          ? 'Temporarily unavailable'
          : (q > 0
              ? `${this.money(this.unitPrice(key))} each` + (this.unitPrice(key) === c.t2 ? ' · best price' : '')
              : 'Not included');
      }
      const matchCb = this.querySelector(`[data-match="${key}"]`);
      if (matchCb) {
        matchCb.checked = !unavailable && !!this.match[key];
        matchCb.disabled = unavailable;
      }

      const stepper = this.querySelector(`[data-stepper="${key}"]`);
      if (stepper) {
        const floor = key === 'game' ? this.packSize : 0;
        stepper.querySelectorAll('[data-dir]').forEach((b) => { b.disabled = unavailable; });
        const minus = stepper.querySelector('[data-dir="-1"]');
        if (minus && !unavailable) minus.disabled = q <= floor;
      }

      if (q > 0) {
        const labels = { game: 'games', devo: 'devotionals', book: 'books' };
        parts.push(`${q} ${labels[key]}`);
      }
    });

    const gameOff = this.unavail('game');
    this.querySelectorAll('.udk-mob__preset').forEach((btn) => {
      btn.disabled = gameOff;
      btn.classList.toggle('is-active', !gameOff && parseInt(btn.dataset.preset, 10) === this.qty.game);
    });

    const savings = retailTotal - subtotal;
    this.querySelector('[data-summary-items]').textContent = parts.join(' · ') || 'Choose your quantities';
    this.querySelector('[data-subtotal]').textContent = this.money(subtotal);
    this.querySelector('[data-savings]').textContent = this.money(savings);
    this.addBtn.disabled = gameOff || this.qty.game < this.packSize;
  }

  buildItems() {
    const items = [];
    ['game', 'devo', 'book'].forEach((key) => {
      if (!this.unavail(key) && this.qty[key] > 0) {
        items.push({ id: this.cfg[key].id, quantity: this.qty[key], properties: { _ministry: 'true' } });
      }
    });
    return items;
  }

  async addToCart() {
    const items = this.buildItems();
    if (!items.length) return;

    this.setLoading(true);
    this.showError('');

    try {
      const res = await fetch(`${window.routes.cart_add_url}`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          Accept: 'application/json',
          'X-Requested-With': 'XMLHttpRequest',
        },
        body: JSON.stringify({ items }),
      });
      const data = await res.json();

      if (data.status) {
        this.showError(data.description || data.message || 'Sorry, something went wrong adding to cart.');
        this.setLoading(false);
        return;
      }

      // Bulk order: send them straight to checkout (skip the cart page) to match the main flow.
      window.location = '/checkout';
    } catch (e) {
      console.error(e);
      this.showError('Something went wrong — please try again.');
      this.setLoading(false);
    }
  }

  setLoading(on) {
    this.addBtn.classList.toggle('is-loading', on);
    this.addBtn.disabled = on || this.unavail('game') || this.qty.game < this.packSize;
    const spinner = this.addBtn.querySelector('.udk-mob__spinner');
    if (spinner) spinner.hidden = !on;
  }

  showError(msg) {
    if (!this.errorEl) return;
    this.errorEl.textContent = msg;
    this.errorEl.hidden = !msg;
  }
}

if (!customElements.get('ministry-gallery')) {
  customElements.define('ministry-gallery', MinistryGallery);
}
if (!customElements.get('ministry-order-builder')) {
  customElements.define('ministry-order-builder', MinistryOrderBuilder);
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["udk-mystery-popup"] && !Shopify.designMode) return;
  try {
    
(function () {
  // udk-capture.js is deferred and may execute before OR after this bundle —
  // init immediately if it's there, otherwise wait for its ready event.
  if (window.UDKCapture) initMysteryPopup();
  else document.addEventListener('udk:capture:ready', initMysteryPopup, { once: true });

  function initMysteryPopup() {
  var root = document.querySelector('.udk-mystery');
  if (!root) return;

  var C = window.UDKCapture; // shared Klaviyo capture utils (assets/udk-capture.js)
  var readState = C.readState;
  var writeState = C.writeState;
  var designMode = root.hasAttribute('data-design-mode');
  var dialog = root.querySelector('.udk-mystery__dialog');
  var steps = root.querySelectorAll('[data-udk-step]');

  var capturedEmail = readState().email || ''; // survives reloads so a resumed phone step still merges onto the right profile

  function subscribe(profileAttrs) {
    return C.subscribe({
      company: root.dataset.company,
      list: root.dataset.list,
      source: 'Mystery Popup', // $source attribution vs the inline form
      profile: profileAttrs
    });
  }

  function shouldShow() {
    var s = readState();
    var now = Date.now();
    if (s.completedAt && now - s.completedAt < 365 * 864e5) return false;
    var snoozeDays = parseFloat(root.dataset.snoozeDays) || 7;
    if (s.dismissedAt && now - s.dismissedAt < snoozeDays * 864e5) return false;
    return true;
  }

  function goTo(n) {
    if (n === 4) fillReveal();
    steps.forEach(function (el) {
      el.classList.toggle('is-active', el.getAttribute('data-udk-step') === String(n));
    });
    var scroller = dialog.querySelector('.udk-mystery__content');
    if (scroller) scroller.scrollTop = 0;
    var focusable = dialog.querySelector('[data-udk-step="' + n + '"] input, [data-udk-step="' + n + '"] a, [data-udk-step="' + n + '"] button');
    if (focusable && n !== 1) setTimeout(function () { focusable.focus({ preventScroll: true }); }, 60);
  }

  var supportsModal = typeof root.showModal === 'function';

  function open() {
    prefetchPuzzleImages(); // no-op if already done; guarantees imgs on any open path
    root.hidden = false;
    if (supportsModal && !root.open) root.showModal(); // top layer: above ALL third-party z-indexes
    document.documentElement.style.overflow = 'hidden';
    var x = root.querySelector('.udk-mystery__x');
    if (x) x.focus({ preventScroll: true });
  }

  // All close paths (X, final CTA, native ESC) funnel through here.
  function finalizeClose() {
    root.hidden = true;
    document.documentElement.style.overflow = '';
    if (designMode) return; // don't snooze the merchant's own preview
    var s = readState();
    if (!s.completedAt) writeState({ dismissedAt: Date.now() });
  }

  function close() {
    if (supportsModal && root.open) root.close(); // fires 'close' -> finalizeClose
    else finalizeClose();
  }

  root.addEventListener('close', finalizeClose); // covers native ESC too

  root.querySelectorAll('[data-udk-close]').forEach(function (el) {
    el.addEventListener('click', close);
  });
  document.addEventListener('keydown', function (e) {
    // fallback ESC for browsers without showModal (native dialogs handle their own)
    if (e.key === 'Escape' && !root.hidden && !(supportsModal && root.open)) close();
  });

  /* ---------- Step 1: puzzle drag ---------- */
  var piece = root.querySelector('[data-udk-piece]');
  var board = root.querySelector('[data-udk-board]');
  var boardWrap = root.querySelector('.udk-mystery__board-wrap');
  var hint = root.querySelector('[data-udk-hint]');
  var solved = false;

  // Hole hotspot as fraction of the rendered board (from asset geometry).
  var HOLE = { x0: 0, y0: 0.45, x1: 0.38, y1: 1.0 };
  // Piece's true footprint on the board: canvas 291/855 wide, placed at (0, 47.42%).
  var PIECE_FRAC = { w: 291 / 855, x: 0, y: 0.4742 };

  function solve() {
    if (solved) return;
    solved = true;
    piece.style.display = 'none';
    if (hint) hint.style.display = 'none';
    board.src = board.src.replace('udk-puzzle-board', 'udk-puzzle-complete');
    boardWrap.classList.add('is-complete');
    setTimeout(function () { goTo(2); }, 950);
  }

  // Slide the dragged piece into its exact slot, then swap in the finished board.
  function snapAndSolve() {
    var r = board.getBoundingClientRect();
    var w = r.width * PIECE_FRAC.w;
    var h = w * (piece.naturalHeight / piece.naturalWidth);
    piece.classList.add('is-snapping');
    piece.style.width = w + 'px';
    piece.style.left = r.left + r.width * PIECE_FRAC.x + w / 2 + 'px';
    piece.style.top = r.top + r.height * PIECE_FRAC.y + h / 2 + 'px';
    setTimeout(function () {
      piece.classList.remove('is-dragging', 'is-snapping');
      piece.style.left = '';
      piece.style.top = '';
      piece.style.width = '';
      solve();
    }, 180);
  }

  function inHole(cx, cy) {
    var r = board.getBoundingClientRect();
    var fx = (cx - r.left) / r.width;
    var fy = (cy - r.top) / r.height;
    return fx >= HOLE.x0 && fx <= HOLE.x1 && fy >= HOLE.y0 && fy <= HOLE.y1;
  }

  var drag = null;
  piece.addEventListener('pointerdown', function (e) {
    if (solved) return;
    e.preventDefault();
    piece.setPointerCapture(e.pointerId);
    drag = { id: e.pointerId, startX: e.clientX, startY: e.clientY, moved: false };
    piece.classList.add('is-dragging');
    // Grow to the piece's real in-board size so the fit reads as perfect.
    piece.style.width = board.getBoundingClientRect().width * PIECE_FRAC.w + 'px';
    movePiece(e.clientX, e.clientY);
  });

  function movePiece(x, y) {
    piece.style.left = x + 'px';
    piece.style.top = y + 'px';
  }

  piece.addEventListener('pointermove', function (e) {
    if (!drag || e.pointerId !== drag.id) return;
    if (Math.abs(e.clientX - drag.startX) + Math.abs(e.clientY - drag.startY) > 6) drag.moved = true;
    movePiece(e.clientX, e.clientY);
  });

  function resetPiece() {
    piece.classList.remove('is-dragging', 'is-snapping');
    piece.style.left = '';
    piece.style.top = '';
    piece.style.width = '';
  }

  function endDrag(e) {
    if (!drag || e.pointerId !== drag.id) return;
    var wasTap = !drag.moved;
    var hit = inHole(e.clientX, e.clientY);
    drag = null;
    if (hit) {
      snapAndSolve(); // glide into the slot — the "perfect fit" moment
    } else {
      resetPiece();
      if (wasTap) solve(); // tap-to-place fallback keeps mobile friction near zero
    }
  }
  piece.addEventListener('pointerup', endDrag);
  piece.addEventListener('pointercancel', function () {
    drag = null;
    resetPiece();
  });
  piece.addEventListener('keydown', function (e) {
    if (e.key === 'Enter' || e.key === ' ') { e.preventDefault(); solve(); }
  });

  /* ---------- Step 2: email ---------- */
  var emailForm = root.querySelector('[data-udk-email-form]');
  emailForm.addEventListener('submit', function (e) {
    e.preventDefault();
    var input = emailForm.querySelector('input[name="email"]');
    var err = emailForm.querySelector('[data-udk-email-error]');
    var btn = emailForm.querySelector('[data-udk-email-btn]');
    if (btn.disabled) return;
    var email = (input.value || '').trim().toLowerCase();
    if (!C.validateEmail(email)) {
      err.textContent = "Hmm — that email doesn't look right. Try again?";
      err.hidden = false;
      return;
    }
    err.hidden = true;
    btn.disabled = true;
    capturedEmail = email;
    subscribe({
      email: email,
      subscriptions: { email: { marketing: { consent: 'SUBSCRIBED' } } }
    }).then(function (r) {
      btn.disabled = false;
      if (r.ok || r.retryable) {
        // retryable = auto-queued in the shared outbox; never block the shopper.
        writeState({ emailAt: Date.now(), email: email });
        goTo(3);
      } else {
        // 4xx: Klaviyo rejected this address — let them fix it.
        err.textContent = "That email was rejected — double-check it and try again.";
        err.hidden = false;
      }
    });
  });

  /* ---------- Step 3: country selector (shared data + init) ---------- */
  var getCountry = C.initCountrySelect(
    root.querySelector('[data-udk-cc]'),
    root.querySelector('[data-udk-cc-flag]')
  );
  /* ---------- Step 3: phone ---------- */
  var phoneForm = root.querySelector('[data-udk-phone-form]');
  phoneForm.addEventListener('submit', function (e) {
    e.preventDefault();
    var input = phoneForm.querySelector('input[name="phone"]');
    var err = phoneForm.querySelector('[data-udk-phone-error]');
    var btn = phoneForm.querySelector('[data-udk-phone-btn]');
    if (btn.disabled) return;
    var dial = getCountry()[1];
    var digits = C.normalizePhone(input.value, dial);
    if (!digits) {
      err.textContent = "That number doesn't look right — double-check and try again.";
      err.hidden = false;
      return;
    }
    err.hidden = true;
    btn.disabled = true;
    // Fall back to persisted state: the closure can be stale if the email was
    // captured by another component (e.g. inline form) after this script ran.
    // Never send SMS-only consent — the profile must carry its email identifier.
    var emailForPhone = capturedEmail || readState().email || '';
    var profileAttrs = {
      phone_number: '+' + dial + digits,
      subscriptions: { sms: { marketing: { consent: 'SUBSCRIBED' } } }
    };
    if (emailForPhone) {
      profileAttrs.email = emailForPhone;
      profileAttrs.subscriptions.email = { marketing: { consent: 'SUBSCRIBED' } };
    }
    subscribe(profileAttrs).then(function (r) {
      btn.disabled = false;
      if (r.ok || r.retryable) {
        // retryable = auto-queued; email is already captured, don't hold the reward hostage.
        finish();
      } else {
        err.textContent = r.detail || "That number was rejected — double-check it and try again.";
        err.hidden = false;
      }
    });
  });

  function finish() {
    writeState({ completedAt: Date.now() });
    goTo(4);
  }

  /* ---------- Step 4: check-your-email ---------- */
  function fillReveal() {
    var email = capturedEmail || readState().email || '';

    // Swap the {email} token in the sub copy for the real address (bolded).
    var sub = root.querySelector('[data-udk-sent-copy]');
    if (sub) {
      var parts = (sub.getAttribute('data-template') || sub.textContent).split('{email}');
      sub.textContent = '';
      parts.forEach(function (part, i) {
        if (i > 0) {
          var strong = document.createElement('strong');
          strong.textContent = email || 'your email';
          sub.appendChild(strong);
        }
        sub.appendChild(document.createTextNode(part));
      });
    }
  }

  /* ---------- Manual re-open (inline teaser sections) ----------
     Bypasses suppression and resumes at the furthest step reached:
     completed -> code screen, email captured -> phone step, else puzzle. */
  document.addEventListener('udk:mystery:open', function () {
    var s = readState();
    if (s.completedAt) goTo(4);
    else if (s.email || capturedEmail) goTo(3);
    else if (solved) goTo(2);
    else goTo(1);
    open();
  });

  /* ---------- Trigger ---------- */
  // Resume at the furthest step reached (a snoozed visitor who already gave
  // email shouldn't redo the puzzle and re-submit their email).
  function openResumed() {
    var s = readState();
    if (s.completedAt) goTo(4);
    else if (s.email || capturedEmail) goTo(3);
    else if (solved) goTo(2);
    open();
  }

  // Puzzle images ship WITHOUT src (data-src only): Chrome fetches even
  // lazy/hidden <dialog> images, which cost ~500KB on every page for every
  // visitor. JS assigns src after page load — and only for visitors who
  // will actually see the popup. Idempotent; also called on every open path.
  function prefetchPuzzleImages() {
    root.querySelectorAll('img[data-src]').forEach(function (img) {
      // eager: these imgs have no intrinsic height until loaded, so a lazy
      // zero-height box never intersects and would deadlock unloaded.
      img.loading = 'eager';
      img.src = img.getAttribute('data-src');
      img.removeAttribute('data-src');
    });
  }

  // Visitors arriving from our own emails are already subscribed — mark them
  // completed (same 365-day suppression as a real signup) so the popup never
  // shows, on this and all future visits from this browser.
  try {
    var qs = new URLSearchParams(location.search);
    if ((qs.get('utm_medium') || '').toLowerCase() === 'email' ||
        (qs.get('utm_source') || '').toLowerCase() === 'klaviyo') {
      if (!readState().completedAt) writeState({ completedAt: Date.now() });
    }
  } catch (e) {}

  if (designMode) {
    // In the theme editor: open only when the merchant selects this section.
    document.addEventListener('shopify:section:select', function (e) {
      if (e.target.contains(root)) { prefetchPuzzleImages(); open(); }
    });
    document.addEventListener('shopify:section:deselect', function (e) {
      if (e.target.contains(root)) close();
    });
  } else if (!root.hasAttribute('data-no-auto') && shouldShow()) {
    if (document.readyState === 'complete') prefetchPuzzleImages();
    else window.addEventListener('load', prefetchPuzzleImages, { once: true });
    setTimeout(openResumed, (parseFloat(root.dataset.delay) || 6) * 1000);
  }
  }
})();

  } catch(e) { console.error(e); }
})();
})();
